import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  theme,
  Col,
  Row,
  Dropdown,
  Space,
  Typography,
  Switch,
  Tooltip,
  Avatar,
  Divider,
} from "antd";
import "./HeaderComponent.scss";
import IconMap from "../../constants/icons.js";

import { changeTheme } from "../../store/actions/basicConifgAction.js";
import { logout as logoututility } from "@utils/utils.js";

const { Header } = Layout;
const { Text } = Typography;
const {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  LogoutOutlined,
  SunOutlined,
  MoonOutlined,
  ReloadOutlined,
  UserOutlined,
} = IconMap;
// console.log("processs>>", process.env.NODE_ENV);

const HeaderComponent = ({ collapsed, setCollapsed, clearCacheAndReload }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetailReducer = useSelector(
    (state) => state.basicConfigReducer?.userdetails || null
  );

  const [nodeEnv] = useState(process.env.NODE_ENV);
  const [userDetails, setuserDetails] = useState(userDetailReducer);
  const [isLightTheme, setisLightTheme] = useState(true);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  useEffect(() => {
    if (userDetailReducer) {
      setuserDetails(userDetailReducer);
    }
  }, [userDetailReducer]);

  const logout = async () => {
    logoututility();
    // navigate(window.location.origin, { replace: true });
    // redirect("/");
  };

  const settingsPage = () => {
    navigate("./logoCustomization");
  };

  const gotoProfilePage = () => {
    navigate("./profile");
  };

  let items = [
    {
      key: "1",
      danger: false,
      label: (
        <>
          <Row>
            <Col span={6}>
              <Avatar size="large">
                {(userDetails &&
                  (userDetails.firstname &&
                    Array.from(userDetails.firstname || <UserOutlined />)[0]) +
                  (userDetails.surname &&
                    Array.from(
                      userDetails.surname || <UserOutlined />
                    )[0])) ||
                  ""}
              </Avatar>
            </Col>
            <Col span={18}>
              <Col span={24}>
                <Text>
                  {(userDetails &&
                    userDetails.firstname + " " + userDetails.surname) ||
                    ""}
                </Text>
              </Col>

              <Col span={24}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {(userDetails && userDetails.email) || ""}
                </Text>
              </Col>
              <Col span={24}>
                <Text style={{ fontSize: "12px" }} type="secondary">
                  {(userDetails &&
                    userDetails.groups &&
                    userDetails.groups.length &&
                    `[${userDetails.groups[0]}]`) ||
                    ""}
                </Text>
              </Col>
            </Col>
          </Row>
          <Divider dashed />
        </>
      ),
    },
    {
      key: "3",
      danger: true,
      label: <Text onClick={() => logout()}>Logout</Text>,
      icon: <LogoutOutlined />,
    },
  ];

  //Remove Settings from items array in case of OrgAdmin
  if (userDetailReducer?.groups?.[0]) {
    let groups = userDetailReducer.groups[0];
    if (["hieadmin", "superuser"].includes(groups.toLowerCase())) {
      items.splice(1, 0, {
        key: "2",
        danger: false,
        label: <Text onClick={() => settingsPage()}>Settings</Text>,
        icon: <SettingOutlined />,
      });
    }
  }

  const changeThemeFunc = (islighttheme) => {
    setisLightTheme(!isLightTheme);
    if (islighttheme) {
      dispatch(changeTheme("white"));
    } else {
      dispatch(changeTheme("dark"));
    }
  };

  
  
  const handleMenuClick = (e) => {
    if (e && e.key === "1") {
      gotoProfilePage();
    } else if (e && e.key === "2") {
      settingsPage();
    } else if (e && e.key === "3") {
      logout();
    }
  };

  return (
    <Header
      className="site-layout-background"
      style={{
        position: "sticky",
        top: 0,
        padding: 0,
        background: colorBgContainer,
        width: "100%",
        zIndex: 1,
        height: "35px",
        lineHeight: "35px",
      }}
    >
      <Row justify="center" align="top">
        <Col md={2}>
          <Button
            size="small"
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={
              {
                // fontSize: "16px",
                // width: 64,
                // height: 64,
              }
            }
          />
        </Col>
        {/* <Col md={6}>
          <img src={onedataconnectlogo} alt="logo" width={200} />
        </Col> */}
        <Col md={21}>
          <Row justify="end">
            {/* <Col> */}
            <Space>
              <Tooltip title="Clear cache and reload">
                <Button
                  size="small"
                  shape="circle"
                  icon={<ReloadOutlined style={{ fontSize: "10px" }} />}
                  onClick={() => clearCacheAndReload()}
                />
              </Tooltip>
              {nodeEnv === "development" && (
                <Switch
                  size="small"
                  checkedChildren={<SunOutlined />}
                  unCheckedChildren={<MoonOutlined />}
                  defaultChecked
                  value={isLightTheme}
                  onChange={(e) => changeThemeFunc(e)}
                />
              )}
              <Dropdown
                overlayClassName="user-dropdown"
                overlayStyle={{ width: 250 }}
                menu={{
                  items,
                  onClick: handleMenuClick,
                }}
              >
                <a href="./" onClick={(e) => e.preventDefault()}>
                  <Avatar size="small">
                    {(userDetails &&
                      (userDetails.firstname &&
                        Array.from(
                          userDetails.firstname || <UserOutlined />
                        )[0]) +
                        (userDetails.surname &&
                          Array.from(
                            userDetails.surname || <UserOutlined />
                          )[0])) ||
                      ""}
                  </Avatar>
                </a>
              </Dropdown>
            </Space>
          </Row>
        </Col>
      </Row>
    </Header>
  );
};

export default HeaderComponent;
